import React,{useState} from "react";
import clsx from "clsx";

import { TableRow, TableCell } from "@material-ui/core";
import { alpha, makeStyles } from "@material-ui/core/styles";
import moment from "moment-jalaali";
import DeleteIcon from "@material-ui/icons/Delete";
import CustomDialog from "../AccessList/CustomDialog";
import { useDispatch } from "react-redux";
import TestsRequests from "services/tests";

const useStyles = makeStyles((theme) => ({
  tableRowRoot: {
    position: "relative",
    transition: "all .2s",
    borderTop: `solid 1px ${theme.palette.borderColor.main}`,
    "&:hover, &.active": {
      backgroundColor: alpha(theme.palette.primary.main, 0.08),
      "& $tableCellRoot, & $titleRoot": {
        color: theme.palette.text.primary,
      },
    },
    "&:last-child": {
      borderBottom: `solid 1px ${theme.palette.borderColor.main}`,
    },
    "&:hover": {
      transform: "translateY(-4px)",
      boxShadow: `0 3px 10px 0 ${alpha(theme.palette.common.dark, 0.2)}`,
      borderTopColor: "transparent",
    },
    "&.collapse-table-row": {
      borderTop: "0 none",
      "& $tableCellRoot": {
        padding: 0,
      },
    },
    "&.active": {
      borderTop: "0 none",
      "&:hover": {
        transform: "none",
        boxShadow: "none",
      },
    },
  },
  tableCellRoot: {
    padding: 6,
    fontSize: 14,
    letterSpacing: 0.25,
    color: theme.palette.text.secondary,
    borderBottom: "0 none",
    position: "relative",
    "&:first-child": {
      paddingLeft: 24,
    },
    "&:last-child": {
      textAlign: "right",
      paddingRight: 24,
    },
  },
  tableCellFirst: {
    minWidth: "150px",
  },
  titleRoot: {
    color: theme.palette.text.secondary,
    letterSpacing: 0.25,
  },
  createIconContainer: {
    background: "transparent",
    color: theme.palette.secondary.main,
    width: "35px",
    height: "35px",
    display: "flex",
    justifyContent: "center",
    alignItems: "center",
    borderRadius: "5px",
    cursor: "pointer",
  },
  tableActionContainer: {
    direction: "rtl",
  },
}));

const CoinManagementTableItem = ({ data, id }) => {
  const classes = useStyles();
  const [openRemoveDialog, setOpenRemoveDialog] = useState(false);
  const dispatch = useDispatch();

  const handleDelete = () => {
    dispatch(TestsRequests.deleteCoin(id));
  };

  return (
    <React.Fragment>
      <TableRow className={clsx(classes.tableRowRoot)}>
        <TableCell
          className={clsx(classes.tableCellRoot, classes.tableCellFirst)}
        >
          {data.owner}
        </TableCell>
        <TableCell
          className={clsx(classes.tableCellRoot, classes.tableCellFirst)}
        >
          {data.coin}
        </TableCell>
        <TableCell
          className={clsx(classes.tableCellRoot, classes.tableCellFirst)}
        >
          {data.reason}
        </TableCell>
        <TableCell
          className={clsx(classes.tableCellRoot, classes.tableCellFirst)}
        >
          {moment(data.createdAt).format("jYYYY/jMM/jDD")}
        </TableCell>

        <TableCell className={clsx(classes.tableCellRoot)}>
          <DeleteIcon
            onClick={() => setOpenRemoveDialog(true)}
            color="error"
            style={{ cursor: "pointer" }}
          />
        </TableCell>
      </TableRow>
      <CustomDialog
        text={"آیا از حذف این مورد اطمینان دارید؟"}
        open={openRemoveDialog}
        handleClose={() => setOpenRemoveDialog(false)}
        action={handleDelete}
      />
    </React.Fragment>
  );
};

export default CoinManagementTableItem;
